function SevenConfirmations() {
  return (
    <div className="portfolio-sevenconfirmations">
      <div className="portfolio-description">
        <p>An ayurvedic product website for PCOS and PCODs</p>
        <p>
          Created an ecommerce system like listing products, Adding to cart,
          Showing price calculations, and implemented PayTM gateway for
          payments.
        </p>
      </div>
      <div className="row">
        <div>
          <iframe
            className="video"
            src="https://www.youtube.com/embed/_M5BnE4Rl0A"
            title="7Confirmations Website Preview"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default SevenConfirmations;
